<template>
  <div class="chart" :style="styleObj">
    <svg :style="styleObj">
      <defs>
        <mask :id="circleClipId">
          <rect fill="white" width="100%" height="100%"></rect>
          <circle fill="black" :cx="size * 0.55" :cy="size * 0.55" :r="size * 0.38"></circle>
        </mask>
      </defs>
      <g :mask="`url(#${circleClipId})`">
        <!-- Empty value -->
        <g class="sector">
          <circle fill="#eee" :cx="size * 0.55" :cy="size * 0.55" :r="size * 0.5" />
        </g>
        <!-- Full 100% -->
        <g class="sector" v-if="processedSectors.length === 1">
          <circle :fill="processedSectors[0].color" :cx="size * 0.55" :cy="size * 0.55" :r="size * 0.5" />
        </g>
        <!-- Sectors -->
        <template v-else>
          <g class="sector" v-for="(s, i) in processedSectors" :key="i">
            <path :fill="s.color" :d="s.d" :transform="s.transform" stroke="white" stroke-width="1"></path>
          </g>
        </template>
      </g>
      <!-- Donut center clip -->
      <circle fill="none" :cx="size * 0.55" :cy="size * 0.55" :r="size * 0.28"></circle>
    </svg>
    <!-- Content in the donut center -->
    <div class="slot">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// Inspiré de https://codepen.io/milesmanners/pen/aEabGV
export default {
  props: {
    size: { type: Number },
    sectors: { type: Array }
  },
  data() {
    return {
      styleObj: {
        width: `${this.size * 1.1}px`,
        height: `${this.size * 1.1}px`
      },
      processedSectors: []
    }
  },
  computed: {
    circleClipId() {
      return `circleClip-${this._uid}`
    },
    total() {
      return this.sectors.reduce((t, s) => t + s.value, 0)
    }
  },
  watch: {
    sectors: {
      handler(val) {
        this.calculateSectors()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    calculateSectors() {
      if (!this.total) return
      // This function calculates circle segments for each sector
      // The segments go all the way to the center, but the circle mask cuts the center out
      let l = this.size / 2
      let rotation = 0

      let x
      let y
      let arcSweep = 1

      this.sectors.forEach((item, key) => {
        if (item.value === 0) return

        let angle = (360 * item.value) / this.total
        let aCalc = angle > 180 ? 360 - angle : angle
        let angleRad = (aCalc * Math.PI) / 180
        let sizeZ = Math.sqrt(2 * l * l - 2 * l * l * Math.cos(angleRad))

        let sideX
        if (aCalc <= 90) {
          sideX = l * Math.sin(angleRad)
        } else {
          sideX = l * Math.sin(((180 - aCalc) * Math.PI) / 180)
        }

        let sideY = Math.sqrt(sizeZ * sizeZ - sideX * sideX)
        y = sideY

        if (angle <= 180) {
          x = l + sideX
          arcSweep = 0
        } else {
          x = l - sideX
          arcSweep = 1
        }

        this.processedSectors.push({
          value: item.value,
          percentage: item.value / this.total,
          label: item.label,
          color: item.color,
          d: `M${l},${l} L${l},0 A${l},${l} 0 ${arcSweep},1 ${x}, ${y} z`,
          transform: `translate(${this.size * 0.05}, ${this.size * 0.05}) rotate(${rotation}, ${l}, ${l})`
        })

        rotation = rotation + angle
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  position: relative;
  text-align: center;
  margin: auto;

  .slot {
    position: absolute;
    width: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
  }

  .sector {
    transform-origin: 50% 50%;
    transition: transform 200ms;

    /* Désactivé l'interactivité qui grossi le secteur survolé
    &:hover {
      transform: scale(1.1);
    }
    */
  }

  text {
    pointer-events: none;
  }

  circle {
    pointer-events: all;
  }
}
</style>